import { render, staticRenderFns } from "./TestItemBrowse.vue?vue&type=template&id=8fe93288"
import script from "./TestItemBrowse.vue?vue&type=script&lang=js"
export * from "./TestItemBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports